import { useState } from "react";

export interface Choice {
  key: string;
  label: string;
}

/**
 * A dropdown of checkboxes over a named set.
 *
 * Takes the *hidden* keys rather than the visible ones, so a choice added
 * later shows up by default instead of silently staying off for anyone who
 * saved a layout before it existed.
 */
export function ColumnPicker({
  label = "Columns",
  choices,
  hidden,
  onChange,
}: {
  label?: string;
  choices: readonly Choice[];
  hidden: string[];
  onChange: (hidden: string[]) => void;
}) {
  const [open, setOpen] = useState(false);
  const visible = choices.length - hidden.length;

  return (
    <div className="field columns-field">
      <label>{label}</label>
      <button onClick={() => setOpen((v) => !v)}>
        {visible} of {choices.length} ▾
      </button>
      {open && (
        <div className="column-picker">
          {choices.map((choice) => (
            <label key={choice.key} className="switch">
              <input
                type="checkbox"
                checked={!hidden.includes(choice.key)}
                onChange={(e) =>
                  onChange(
                    e.target.checked
                      ? hidden.filter((k) => k !== choice.key)
                      : [...hidden, choice.key],
                  )
                }
              />
              <span>{choice.label}</span>
            </label>
          ))}
          <button className="ghost" onClick={() => onChange([])}>
            Show all
          </button>
        </div>
      )}
    </div>
  );
}
